import {useTranslation} from 'react-i18next';
import PhoneHandset from '../../../../../assets/icons/PhoneHandset';
import PersonCircle from '../../../../../assets/icons/PersonCircle';
import {BLACK} from '../../../../../globalVariables/GlobalVariables';
import {TOrderChangePhonePayload} from '../../../../../redux/crm/crm.type';
import * as css from './OrderMetaRow.css';
import {formatCurrentPhoneDisplay} from '../../utils';

type Props = {
    orderData: TOrderChangePhonePayload;
};

export default function OrderMetaRow({orderData}: Props) {
    const {t} = useTranslation('layout');
    return (
        <css.metaRowWrap>
            {(orderData.firstName || orderData.lastName) && (
                <css.metaChunk>
                    <PersonCircle width={24} height={24} fill={BLACK} />
                    <css.metaText>{orderData.firstName} {orderData.lastName}</css.metaText>
                </css.metaChunk>
            )}
            {orderData.phone && (
                <css.metaChunk>
                    <PhoneHandset size={24} />
                    <css.metaText>{t('orderChangePhoneCurrentShort', {phone: formatCurrentPhoneDisplay(orderData.phone)})}</css.metaText>
                </css.metaChunk>
            )}
        </css.metaRowWrap>
    );
}
